type StepDef = {
  label: string;
  icon: 'user' | 'location' | 'payment';
};

type Props = {
  steps: StepDef[];
  current: number;
};

function UserIcon() {
  return (
    <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
      <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
      <path
        fill-rule="evenodd"
        d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.274 1.765 11.842 11.842 0 00.976.544l.062.029.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
        clip-rule="evenodd"
      />
    </svg>
  );
}

function PaymentIcon() {
  return (
    <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
      <path
        fill-rule="evenodd"
        d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
        clip-rule="evenodd"
      />
    </svg>
  );
}

function StepIcon({ type }: { type: 'user' | 'location' | 'payment' }) {
  switch (type) {
    case 'user':
      return <UserIcon />;
    case 'location':
      return <LocationIcon />;
    case 'payment':
      return <PaymentIcon />;
  }
}

export function WizardProgressBar({ steps, current }: Props) {
  return (
    <div class="flex items-center justify-center gap-0 mb-8">
      {steps.map((step, i) => {
        const isCompleted = i < current;
        const isCurrent = i === current;
        const isActive = isCompleted || isCurrent;

        return (
          <div key={i} class="flex items-center">
            <div class="flex flex-col items-center">
              <div
                class={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
                  isActive ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-400'
                }`}
              >
                <StepIcon type={step.icon} />
              </div>
              <span
                class={`text-xs mt-1 hidden sm:block ${
                  isActive ? 'text-blue-600 font-medium' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                class={`w-12 sm:w-16 h-0.5 mx-1 self-start ${isCompleted ? 'bg-blue-600' : 'bg-gray-200'}`}
                style="margin-top: 19px"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
